export default {
  items: [
    {
      name: "Dashboard",
      url: "/",
      icon: "icon-speedometer",
      badge: {
        variant: "info",

      },
    },
    {
      name: "Tenants",
      url: "/app/tenants",
      icon: "icon-people"
    },
    {
      name: "Groups",
      url: "/app/v2/groups",
      icon: "icon-people"
    }

  ],
};
